import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h5", { class: "fw-bold text-black mb-3" }, "Acudiente 1", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "att1-name"
}, "Nombre Acudiente", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "att1-lastname"
}, "Apellido", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "att1-phone"
}, "Teléfono", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "att1-address"
}, "Dirección", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "att1-email"
}, "Correo electrónico", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "att1-relationship"
}, "Parentesco", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h5", { class: "fw-bold text-black mb-3" }, "Acudiente 2", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "att2-name"
}, "Nombre Acudiente", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "att2-lastname"
}, "Apellido", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "att2-phone"
}, "Teléfono", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "att2-address"
}, "Dirección", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "att2-email"
}, "Correo electrónico", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "att2-relationship"
}, "Parentesco", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h5", { class: "fw-bold text-black mb-3" }, "Acudiente 3", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "att3-name"
}, "Nombre Acudiente", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "att3-lastname"
}, "Apellido", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "att3-phone"
}, "Teléfono", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "att3-address"
}, "Dirección", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "att3-email"
}, "Correo electrónico", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "att3-relationship"
}, "Parentesco", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("h5", { class: "fw-bold text-black mb-3" }, "Acudiente 4", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "att4-name"
}, "Nombre Acudiente", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "att4-lastname"
}, "Apellido", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "att4-phone"
}, "Teléfono", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "att4-address"
}, "Dirección", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "att4-email"
}, "Correo electrónico", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "att4-relationship"
}, "Parentesco", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_form_input = _resolveComponent("b-form-input")!
  const _component_b_form_invalid_feedback = _resolveComponent("b-form-invalid-feedback")!
  const _component_b_form_group = _resolveComponent("b-form-group")!
  const _component_b_col = _resolveComponent("b-col")!
  const _component_b_row = _resolveComponent("b-row")!
  const _component_b_form_checkbox = _resolveComponent("b-form-checkbox")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_2,
                _createVNode(_component_b_form_input, {
                  id: "att1-name",
                  class: _normalizeClass(["form-control fs-14 text-black shadow-none form-control-sm", { 'is-invalid': _ctx.wasValidated && !_ctx.recordProxy.Attendant1Name }]),
                  modelValue: _ctx.recordProxy.Attendant1Name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = val => _ctx.updateField('Attendant1Name', val)),
                  placeholder: "Ingrese nombre",
                  type: "text",
                  required: ""
                }, null, 8, ["modelValue", "class"]),
                _createVNode(_component_b_form_invalid_feedback, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Campo requerido")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_3,
                _createVNode(_component_b_form_input, {
                  id: "att1-lastname",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.Attendant1LastName,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = val => _ctx.updateField('Attendant1LastName', val)),
                  placeholder: "Ingrese apellido",
                  type: "text"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_4,
                _createVNode(_component_b_form_input, {
                  id: "att1-phone",
                  class: _normalizeClass(["form-control fs-14 text-black shadow-none form-control-sm", { 'is-invalid': _ctx.wasValidated && !_ctx.recordProxy.Attendant1PhoneNumber }]),
                  modelValue: _ctx.recordProxy.Attendant1PhoneNumber,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = val => _ctx.updateField('Attendant1PhoneNumber', val)),
                  placeholder: "Ingrese teléfono",
                  type: "text",
                  required: ""
                }, null, 8, ["modelValue", "class"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_5,
                _createVNode(_component_b_form_input, {
                  id: "att1-address",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.Attendant1Address,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = val => _ctx.updateField('Attendant1Address', val)),
                  placeholder: "Ingrese dirección",
                  type: "text"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_6,
                _createVNode(_component_b_form_input, {
                  id: "att1-email",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.Attendant1Email,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = val => _ctx.updateField('Attendant1Email', val)),
                  placeholder: "Ingrese email",
                  type: "email"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_7,
                _createVNode(_component_b_form_input, {
                  id: "att1-relationship",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.Attendant1Relationship,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = val => _ctx.updateField('Attendant1Relationship', val)),
                  placeholder: "Ingrese parentesco",
                  type: "text"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _createVNode(_component_b_form_checkbox, {
                  modelValue: _ctx.recordProxy.Attendant1IsEmergencyContact,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = val => _ctx.updateField('Attendant1IsEmergencyContact', !!val))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Contacto de emergencia ")
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _hoisted_8,
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_9,
                _createVNode(_component_b_form_input, {
                  id: "att2-name",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.Attendant2Name,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = val => _ctx.updateField('Attendant2Name', val)),
                  placeholder: "Ingrese nombre",
                  type: "text"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_10,
                _createVNode(_component_b_form_input, {
                  id: "att2-lastname",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.Attendant2LastName,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = val => _ctx.updateField('Attendant2LastName', val)),
                  placeholder: "Ingrese apellido",
                  type: "text"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_11,
                _createVNode(_component_b_form_input, {
                  id: "att2-phone",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.Attendant2PhoneNumber,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = val => _ctx.updateField('Attendant2PhoneNumber', val)),
                  placeholder: "Ingrese teléfono",
                  type: "text"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_12,
                _createVNode(_component_b_form_input, {
                  id: "att2-address",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.Attendant2Address,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = val => _ctx.updateField('Attendant2Address', val)),
                  placeholder: "Ingrese dirección",
                  type: "text"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_13,
                _createVNode(_component_b_form_input, {
                  id: "att2-email",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.Attendant2Email,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = val => _ctx.updateField('Attendant2Email', val)),
                  placeholder: "Ingrese email",
                  type: "email"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_14,
                _createVNode(_component_b_form_input, {
                  id: "att2-relationship",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.Attendant2Relationship,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = val => _ctx.updateField('Attendant2Relationship', val)),
                  placeholder: "Ingrese parentesco",
                  type: "text"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _createVNode(_component_b_form_checkbox, {
                  modelValue: _ctx.recordProxy.Attendant2IsEmergencyContact,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = val => _ctx.updateField('Attendant2IsEmergencyContact', !!val))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Contacto de emergencia ")
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _hoisted_15,
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_16,
                _createVNode(_component_b_form_input, {
                  id: "att3-name",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.Attendant3Name,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = val => _ctx.updateField('Attendant3Name', val)),
                  placeholder: "Ingrese nombre",
                  type: "text"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_17,
                _createVNode(_component_b_form_input, {
                  id: "att3-lastname",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.Attendant3LastName,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = val => _ctx.updateField('Attendant3LastName', val)),
                  placeholder: "Ingrese apellido",
                  type: "text"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_18,
                _createVNode(_component_b_form_input, {
                  id: "att3-phone",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.Attendant3PhoneNumber,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = val => _ctx.updateField('Attendant3PhoneNumber', val)),
                  placeholder: "Ingrese teléfono",
                  type: "text"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_19,
                _createVNode(_component_b_form_input, {
                  id: "att3-address",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.Attendant3Address,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = val => _ctx.updateField('Attendant3Address', val)),
                  placeholder: "Ingrese dirección",
                  type: "text"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_20,
                _createVNode(_component_b_form_input, {
                  id: "att3-email",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.Attendant3Email,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = val => _ctx.updateField('Attendant3Email', val)),
                  placeholder: "Ingrese email",
                  type: "email"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_21,
                _createVNode(_component_b_form_input, {
                  id: "att3-relationship",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.Attendant3Relationship,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = val => _ctx.updateField('Attendant3Relationship', val)),
                  placeholder: "Ingrese parentesco",
                  type: "text"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _createVNode(_component_b_form_checkbox, {
                  modelValue: _ctx.recordProxy.Attendant3IsEmergencyContact,
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = val => _ctx.updateField('Attendant3IsEmergencyContact', !!val))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Contacto de emergencia ")
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _hoisted_22,
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_23,
                _createVNode(_component_b_form_input, {
                  id: "att4-name",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.Attendant4Name,
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = val => _ctx.updateField('Attendant4Name', val)),
                  placeholder: "Ingrese nombre",
                  type: "text"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_24,
                _createVNode(_component_b_form_input, {
                  id: "att4-lastname",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.Attendant4LastName,
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = val => _ctx.updateField('Attendant4LastName', val)),
                  placeholder: "Ingrese apellido",
                  type: "text"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_25,
                _createVNode(_component_b_form_input, {
                  id: "att4-phone",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.Attendant4PhoneNumber,
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = val => _ctx.updateField('Attendant4PhoneNumber', val)),
                  placeholder: "Ingrese teléfono",
                  type: "text"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_26,
                _createVNode(_component_b_form_input, {
                  id: "att4-address",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.Attendant4Address,
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = val => _ctx.updateField('Attendant4Address', val)),
                  placeholder: "Ingrese dirección",
                  type: "text"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_27,
                _createVNode(_component_b_form_input, {
                  id: "att4-email",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.Attendant4Email,
                  "onUpdate:modelValue": _cache[25] || (_cache[25] = val => _ctx.updateField('Attendant4Email', val)),
                  placeholder: "Ingrese email",
                  type: "email"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_28,
                _createVNode(_component_b_form_input, {
                  id: "att4-relationship",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.Attendant4Relationship,
                  "onUpdate:modelValue": _cache[26] || (_cache[26] = val => _ctx.updateField('Attendant4Relationship', val)),
                  placeholder: "Ingrese parentesco",
                  type: "text"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _createVNode(_component_b_form_checkbox, {
                  modelValue: _ctx.recordProxy.Attendant4IsEmergencyContact,
                  "onUpdate:modelValue": _cache[27] || (_cache[27] = val => _ctx.updateField('Attendant4IsEmergencyContact', !!val))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Contacto de emergencia ")
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}